/**
 * Floor-joist layout for the rectangular engines.
 *
 * Joists run along the building length and are spaced across the width: the
 * first and last sit flush with the outer faces and the rest are spread evenly
 * between them, never wider than `cc`. Positions are joist CENTRES measured
 * from the building's centre line, in metres.
 *
 * Lives in the domain layer (no Three.js) so anything that needs to draw or
 * count the joists — the 3D builder, the BOM, the landing page's joist plan —
 * reads the same layout instead of re-deriving it.
 */
export function resolveFloorJoistLayout(
	width: number,
	joistWidth: number,
	cc: number,
) {
	const numFloorJoists = Math.ceil((width - joistWidth) / cc) + 1;
	const floorSpacing = (width - joistWidth) / Math.max(1, numFloorJoists - 1);
	const joistPositions = Array.from(
		{ length: numFloorJoists },
		(_, index) => -width / 2 + joistWidth / 2 + index * floorSpacing,
	);

	return {
		numFloorJoists,
		floorSpacing,
		joistPositions,
	};
}
